import '../../AppInit.css';var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { jsx } from "react/jsx-runtime";
import * as ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { Router } from "react-router-dom";
import history from "@ane/core/lib/CreateHistory";
import NavigationService from "@ane/core/lib/services/NavigationService";
import dispatchRouteUpdateOnHistoryLocation from "@ane/core/lib/services/syncUrlAndStore/DispatchRouteUpdateOnHistoryLocation";
import Logger from "@ane/core/lib/services/logging/Logger";
import { AppTelemetryEventNames } from "@ane/exp-data/lib/telemetry/AppTelemetryEventNames";
import { PLTTelemetryEventNames } from "@ane/exp-data/lib/telemetry/PLTTelemetryEventNames";
import { initializeIcons } from "@ane/ui-components/lib/Icons";
import { logPltAndPerfTiming } from "@ane/core/lib/services/logging/Logger.utils";
import { LoggingBootstrapper } from "../../services/logging/LoggingBootstrapper/LoggingBootstrapper.js";
import { UserUtilsInstance } from "@ane/core/lib/utils/UserUtils";
import AuthShell from "../Auth/AuthShell.js";
import { registerCustomIcons } from "../../styling/fonts.js";
import { CompatRouter } from "react-router-dom-v5-compat";
const AppInit$1 = "";
document.onvisibilitychange = () => {
  if (document.visibilityState === "hidden") {
    Logger.trackEvent({
      name: AppTelemetryEventNames.App_Page_hidden,
      properties: {},
      measurements: {}
    });
  } else {
    Logger.trackEvent({
      name: AppTelemetryEventNames.App_Page_visible,
      properties: {},
      measurements: {}
    });
  }
};
window.onbeforeunload = (event) => {
  Logger.trackEvent({
    name: AppTelemetryEventNames.App_Page_close,
    properties: {},
    measurements: {}
  });
};
class AppInit {
  constructor(props) {
    __publicField(this, "store");
    __publicField(this, "children");
    const { children, store } = props;
    this.children = children;
    this.store = store;
    registerCustomIcons();
  }
  initialize() {
    return __async(this, null, function* () {
      logPltAndPerfTiming(PLTTelemetryEventNames.PLT_App_initialize, Logger, performance.now());
      NavigationService.setHistory(history);
      LoggingBootstrapper();
      initializeIcons();
      return true;
    });
  }
  start() {
    return __async(this, null, function* () {
      Logger.trackMetric({
        name: PLTTelemetryEventNames.PLT_App_start,
        average: performance.now(),
        properties: {
          url: document.location.href
        }
      });
      const initialized = yield this.initialize().catch((e) => {
        throw e;
      });
      if (initialized) {
        yield this.renderShell().catch((e) => {
          throw e;
        });
        this.checkBrowserCompatibility();
      }
    });
  }
  renderComponent(component, element, callback) {
    ReactDOM.render(component, element, callback);
  }
  renderShell() {
    const placeHolder = document.getElementsByClassName("root-container")[0];
    dispatchRouteUpdateOnHistoryLocation(this.store, history);
    return new Promise((resolve, reject) => {
      this.renderComponent(
        /* @__PURE__ */ jsx(AuthShell, { history, children: /* @__PURE__ */ jsx(Provider, { store: this.store, children: /* @__PURE__ */ jsx(Router, { history, children: /* @__PURE__ */ jsx(CompatRouter, { children: this.children }) }) }) }),
        placeHolder,
        () => {
          logPltAndPerfTiming(PLTTelemetryEventNames.PLT_Shell_Rendered, Logger, performance.now());
        }
      );
      resolve();
    });
  }
  checkBrowserCompatibility() {
    if (!UserUtilsInstance.isBrowserSupported()) {
      const { name = "", version = "", os = "" } = UserUtilsInstance.getBrowser() || {};
      Logger.log("Showed incompatible browser banner.", {
        browserName: name,
        browserVersion: version,
        OS: os
      });
    }
  }
}
document.AppInit = AppInit;
export {
  AppInit
};
//# sourceMappingURL=AppInit.js.map
